import { ConsumerLocale } from '../types/ConsumerLocale';
import { BrowserLanguage } from '../types/BrowserLanguage';

/**
 * Get language locale from browser
 */
const getUserPreferredLanguage = (): BrowserLanguage => {
	const language = navigator.language;
	const parts = language.split('-');

	if (parts.length > 1) {
		return {
			languageCode: parts[0].toLowerCase(),
			countryCode: parts[1].toUpperCase()
		};
	} else {
		return {
			languageCode: parts[0].toLowerCase(),
			countryCode: null
		};
	}
};

export const getSupportedBrowserDefaultConsumerLocale = (
	supportedLanguages: ConsumerLocale[] | [] | undefined
): string => {
	const { languageCode } = getUserPreferredLanguage();
	const [primaryLanguageCode] = languageCode.split(/[-_]/);
	const primaryLanguageCodeLower = primaryLanguageCode.toLowerCase();

	const matchedLanguage = supportedLanguages?.find(({ consumerLocaleId }) => {
		const [supportedPrimaryCode] = consumerLocaleId.split(/[-_]/);
		return supportedPrimaryCode.toLowerCase() === primaryLanguageCodeLower;
	});

	if (matchedLanguage) {
		return matchedLanguage.consumerLocaleId;
	}

	const englishLanguage = supportedLanguages?.find(({ lioLocaleIso }) =>
		lioLocaleIso.toLowerCase() === 'en'
	);

	let fallbackLanguage = '';
	if (supportedLanguages !== undefined && supportedLanguages.length > 0) {
		fallbackLanguage = supportedLanguages[0].consumerLocaleId;
	}
	return englishLanguage?.consumerLocaleId || fallbackLanguage;
};